/* eslint-disable no-mixed-spaces-and-tabs,no-tabs,no-underscore-dangle,prefer-destructuring */

// eslint-disable-next-line no-var
import { EVENTS } from '../../../app/constants/events';

// eslint-disable-next-line no-var
var ComponentsOrderEditor = class ComponentsOrderEditor {
  constructor($rootScope) {
    this._$rootScope = $rootScope;
  }

  $onInit() {
    this.left = this.components[0];
    this.right = this.components[1];
  }

  switch() {
    if (this.components.length >= 2 && !(this.components.includes(null) || this.components.includes(undefined))) {
      const rightCopy = this.right;

      this.right = this.left;
      this.left = rightCopy;

      this.components[0] = this.left;
      this.components[1] = this.right;

      this._$rootScope.$broadcast(EVENTS.COMPONENTS_ORDER_EDITOR_SWITCH, this.components);
    }
  }
};

xplenty.component('componentsOrderEditor', {
  controller: ['$rootScope', ComponentsOrderEditor],
  // eslint-disable-next-line global-require
  template: require('../../../views/directives/components-order-editor.html'),
  bindings: {
    components: '<',
    disableSwitch: '=?',
  },
});
